import React from 'react';
import Icon from 'components/Icon';
import LabelForm from 'components/Form/LabelForm';
import useMultiLanguage from 'hook/useMultiLanguage';
import FormMessage from 'components/Form/FormMessage';
import { MailOutlined } from '@ant-design/icons';
import { FormItemStyled, InputStyled } from 'components/Form/styled';
import { MAX_LENGTH_EMAIL } from 'constant/inputMaxlength';
import { CHECK_EMAIL } from 'constant/regex';

const FormItemValidateEmail = ({ maxLength, onChange, name }) => {
  const {
    FORM_EMAIL_ADDRESS_LABEL,
    FORM_EMAIL_ADDRESS_PLACEHOLDER,
    FORM_EMAIL_ADDRESS_ERROR_MESSAGE_EMPTY,
    FORM_EMAIL_ADDRESS_ERROR_MESSAGE_VALIDATE,
  } = useMultiLanguage();

  return (
    <>
      <FormItemStyled
        name={name}
        label={<LabelForm text={FORM_EMAIL_ADDRESS_LABEL} />}
        rules={[
          {
            required: true,
            message: (
              <FormMessage
                text1={FORM_EMAIL_ADDRESS_ERROR_MESSAGE_EMPTY}
                marginBottom={'12px'}
              />
            ),
          },
          {
            pattern: CHECK_EMAIL,
            message: (
              <FormMessage
                text1={FORM_EMAIL_ADDRESS_ERROR_MESSAGE_VALIDATE}
                marginBottom={'12px'}
              />
            ),
          },
        ]}
      >
        <InputStyled
          className="input-responsive"
          prefix={
            <Icon>
              <MailOutlined className="icon" />
            </Icon>
          }
          placeholder={FORM_EMAIL_ADDRESS_PLACEHOLDER}
          maxLength={maxLength ? maxLength : MAX_LENGTH_EMAIL}
          onChange={onChange}
        />
      </FormItemStyled>
    </>
  );
};

export default FormItemValidateEmail;
